import VinettaContainer from './vinetta_container';

const Vinetta = VinettaContainer;
export default Vinetta;
